





import FitIcon from '@/fit-ui/packages/icon';
import { FitToast } from '@/fit-ui';
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from './store';

@Component({
  components: {
    FitIcon,
    FitToast,
  },
})
export default class FitLoading extends Vue {
  get showDotLine() {
    return false;
  }
  public toast = store.toast;
  @Prop({ default: 'tick' }) public type!: string;
}
